<template>
  <div id="form" class="profil-choice recommandation-form u-bg--white u-align--left">

    <!-- Recap des questions précédentes -->
    <steps-container />

    <!-- Title en cours du form -->
    <title-with-link :text="title" :nameLink="nameLink" :href="href" v-if="hasLink"/>

    <!--<div class="treatment-title">
      <title-simple :text="'Recommandation du traitement :'" :hasBlock="true"/>
      <print-button/>
    </div>-->

    <title-simple v-else :text="title" :isTitleReco="isTitleReco"/>

    <!-- Contenu du formulaire -->
    <slot></slot>

  </div>
</template>

<script>
  import TitleWithLink from "./../Form/Parts/Choice/Granular/TitleWithLink";
  import StepsContainer from "./../Form/Parts/StepsContainer";

  import { mapGetters, mapActions } from 'vuex'
  import TitleSimple from "../Core/TitleSimple";

  export default {
    name: "FormLayout",
    components: {TitleSimple, TitleWithLink, StepsContainer},
    methods: {
      ...mapActions({
        setCurrentQuestionId: 'setCurrentQuestionId'
      })
    },
    props: ['title', 'nameLink', 'href', 'hasLink', 'isTitleReco']
  }
</script>

<style lang="scss">
  .recommandation-form {
    box-shadow: 0 2px 6px 0 rgba(0,0,0,0.08);
    border: 1px solid color(border);

    .prevent-error {
      display: flex;
      align-items: center;

      svg {
        margin-right: rem(5px);
      }
    }

    .case {
      padding-top: rem(40px);

      ul {
        box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.08);
        background-color: color(grey);
        border: 1px solid color(border);

        li {
          padding: rem(15px) rem(30px);
          list-style: none;
          border-bottom: 1px solid color(border);

          &:last-child {
            border-bottom: 0;
          }
        }
      }
    }
  }
</style>